import { call, put, takeEvery } from 'redux-saga/effects';
import { message } from 'antd';
import { createNewCounty } from '../../requests/create_new_county_request';
import { createNewCountySuccess, createNewCountyFailure } from '../actions/create_new_county.actions';
import { LEAD_CREATE_COUNTY_CREATE_REQUEST } from '../constants/lead_create_county_create.constants';

function* LeadCreateCountyCreateRequest({ params }) {
    const { result, options, error } = yield call(createNewCounty, params);

    if (result) {
        yield put(createNewCountySuccess(options));
        message.success(`County ${options.name} successfully created`);
    } else if (error.code === 11000) {
        yield put(createNewCountyFailure(error.errmsg));
        message.error(`County with ${options.name} name already exist!`);
    } else {
        yield put(createNewCountyFailure(error.errmsg || error));
        message.error(error.errmsg || 'Something went wrong, try again, please');
    }
}

export default function* LeadCreateCountyCreateSaga() {
    yield takeEvery(LEAD_CREATE_COUNTY_CREATE_REQUEST, LeadCreateCountyCreateRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_create/redux/sagas/create_new_county.saga.js